module.exports = __webpack_public_path__ + "static/img/tvuLogo.790ff04b.png";